import { element } from 'angular';

function hsvToHexRgb(a, h, s?, v?) {
  if (typeof h === 'object') {
    s = h.s;
    v = h.v;
    h = h.h;
  }

  let i = Math.floor(h * 6);
  let f = h * 6 - i;
  let p = v * (1 - s);
  let q = v * (1 - f * s);
  let t = v * (1 - (1 - f) * s);

  let r;
  let g;
  let b;

  switch (i % 6) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = p;
      g = v;
      b = t;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      b = q;
      break;
    default:
      break;
  }

  r = Math.floor(r * 255);
  g = Math.floor(g * 255);
  b = Math.floor(b * 255);
  if (a === 1) {
    r += 256;
    g += 256;
    b += 256;
    return '#' + r.toString(16).slice(1) + g.toString(16).slice(1) + b.toString(16).slice(1);
  } else {
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
  }
}

function rgbaTohexRgb(rgba) {
  rgba.r += 256;
  rgba.g += 256;
  rgba.b += 256;
  return '#' + rgba.r.toString(16).slice(1) + rgba.g.toString(16).slice(1) + rgba.b.toString(16).slice(1);
}

function hexRgbToHsv(hexRgb) {
  let tokens = /^#(..)(..)(..)$/.exec(hexRgb);

  if (tokens) {
    let rgb = tokens.slice(1).map(hex => parseInt(hex, 16) / 255);

    let r = rgb[0];
    let g = rgb[1];
    let b = rgb[2];
    let h;
    let s;
    let v = Math.max(r, g, b);
    let diff = v - Math.min(r, g, b);
    let diffc = c => (v - c) / 6 / diff + 1 / 2;

    if (diff === 0) {
      h = s = 0;
    } else {
      s = diff / v;

      let rr = diffc(r);
      let gg = diffc(g);
      let bb = diffc(b);

      if (r === v) {
        h = bb - gg;
      } else if (g === v) {
        h = 1 / 3 + rr - bb;
      } else if (b === v) {
        h = 2 / 3 + gg - rr;
      }

      if (h < 0) {
        h += 1;
      } else if (h > 1) {
        h -= 1;
      }
    }

    return {
      h: h,
      s: s,
      v: v,
    };
  }
  return undefined;
}

export let ColorPickerDirective = [
  '$window',
  $window => {
    // Introduce custom elements for IE8
    $window.document.createElement('color-picker');

    let tmpl =
      '' +
      '<div class="angular-color-picker-container" ng-mouseleave="isOpen=false">' +
      '<div ng-style="{\'background-color\' : color}" class="angular-color-picker-select">' +
      '<button ng-click="isOpen=!isOpen" class="dropdown"></button>' +
      '</div>' +
      '<div ng-show="isOpen" class="angular-color-picker">' +
      '    <div class="_variations" ng-style="{\'background-color\' : hueBackgroundColor}">' +
      '        <div class="_whites">' +
      '            <div class="_blacks">' +
      '                <div class="_cursor" ng-if="colorCursor" ' +
      "                     ng-style=\"{'left' : (colorCursor.x - 5) + 'px', 'top' : (colorCursor.y - 5 + 'px'), 'background-color' : color}\"></div>" +
      '                <div class="_mouse-trap" ng-mousedown="startDrag($event, \'color\')"></div>' +
      '            </div>' +
      '        </div>' +
      '    </div>' +
      '    <div class="_hues">' +
      '        <div class="_ie-1"></div>' +
      '        <div class="_ie-2"></div>' +
      '        <div class="_ie-3"></div>' +
      '        <div class="_ie-4"></div>' +
      '        <div class="_ie-5"></div>' +
      '        <div class="_ie-6"></div>' +
      '        <div class="_cursor" ng-style="{\'top\' : (hueCursor - 5) + \'px\'}"></div>' +
      '        <div class="_mouse-trap" ng-mousedown="startDrag($event, \'hue\')"></div>' +
      '    </div>' +
      '    <div class="_opacity">' +
      "       <div class=\"_opacityContainer\" ng-style=\"{'background' : 'linear-gradient(90deg, rgba(255, 0, 0, 0), '+hueBackgroundColorB+')'}\">" +
      '           <input class="opacity-cursor" type=range min=0 max=1 step="0.01" ng-model="opacity">' +
      '       </div>' +
      '    </div>' +
      '    <div>' +
      '       <input class="raw-value" type="text" ng-model="ngModel">' +
      '    </div>' +
      '</div>' +
      '</div>';

    return {
      restrict: 'AE',
      template: tmpl,
      replace: true,
      require: 'ngModel',
      scope: {
        ngModel: '=',
      },

      link: (scope, elem, $attributes, ngModel) => {
        scope.hsv = { h: 0, s: 0, v: 0 };
        scope.opacity = scope.$eval($attributes.opacity) || 1;
        scope.hsvColor = null;
        scope.isOpen = scope.$eval($attributes.open) || false;

        if (ngModel) {
          ngModel.$render = () => {
            let hexRgbRegexp = /^#[0-9A-Fa-f]{6}$/;
            let rgbARegexp = /^rgba\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/;
            if (hexRgbRegexp.test(ngModel.$viewValue)) {
              scope.color = ngModel.$viewValue;
              scope.hsv = hexRgbToHsv(scope.color);
              scope.colorCursor = {
                x: scope.hsv.s * 130,
                y: (1 - scope.hsv.v) * 130,
              };
              scope.opacity = 1;
            } else if (rgbARegexp.test(ngModel.$viewValue)) {
              let result = ngModel.$viewValue.match(rgbARegexp);
              let rgba = {
                r: parseInt(result[1], 10),
                g: parseInt(result[2], 10),
                b: parseInt(result[3], 10),
                a: parseFloat(result[4]),
              };
              scope.color = rgbaTohexRgb(rgba);
              scope.hsv = hexRgbToHsv(scope.color);
              scope.colorCursor = {
                x: scope.hsv.s * 130,
                y: (1 - scope.hsv.v) * 130,
              };
              // If the opacity does not change, the watch does work and the color picker opacity is not set
              if (scope.opacity === rgba.a) {
                applyOpacity(rgba.a);
              }
              scope.opacity = rgba.a;
            } else {
              scope.color = null;
              scope.hsv = { h: 0 };
              scope.colorCursor = null;
            }
            scope.hueBackgroundColorA = hsvToHexRgb(scope.opacity, scope.hsv.h, 1, 1);
            scope.hueBackgroundColorB = hsvToHexRgb(1, scope.hsv.h, scope.hsv.s, scope.hsv.v);
            scope.hueBackgroundColor = hsvToHexRgb(1, scope.hsv.h, 1, 1);
            scope.hueCursor = scope.hsv.h * 130;
          };
        }

        let dragSubject;
        let dragRect;

        scope.$watch('opacity', data => {
          applyOpacity(data);
        });

        function applyOpacity(data) {
          scope.color = hsvToHexRgb(data, scope.hsv);
          scope.hueBackgroundColorA = hsvToHexRgb(data, scope.hsv.h, 1, 1);
          if (ngModel) {
            ngModel.$setViewValue(scope.color);
          }
        }

        function doDrag(x, y) {
          x = Math.max(Math.min(x, dragRect.width), 0);
          y = Math.max(Math.min(y, dragRect.height), 0);

          if (dragSubject === 'hue') {
            scope.hueCursor = y;
            scope.hsv.h = y / dragRect.height;
          } else {
            scope.colorCursor = {
              x: x,
              y: y,
            };
            scope.hsv.s = x / dragRect.width;
            scope.hsv.v = 1 - y / dragRect.height;
          }
          if (typeof scope.hsv.s !== 'undefined') {
            scope.color = hsvToHexRgb(scope.opacity, scope.hsv);
            if (ngModel) {
              ngModel.$setViewValue(scope.color);
              scope.hueCursor = scope.hsv.h * 130;
            }
          }
          scope.hueBackgroundColorA = hsvToHexRgb(scope.opacity, scope.hsv.h, 1, 1);
          scope.hueBackgroundColorB = hsvToHexRgb(1, scope.hsv.h, scope.hsv.s, scope.hsv.v);
          scope.hueBackgroundColor = hsvToHexRgb(1, scope.hsv.h, 1, 1);
        }

        function onMouseMove(evt) {
          evt.preventDefault();

          scope.$apply(() => {
            doDrag(evt.clientX - dragRect.x, evt.clientY - dragRect.y);
          });
        }

        function onMouseUp() {
          element($window).off('mousemove', onMouseMove);
        }

        scope.startDrag = (evt, subject) => {
          let rect = evt.target.getBoundingClientRect();

          dragSubject = subject;
          dragRect = {
            x: rect.left,
            y: rect.top,
            width: rect.right - rect.left,
            height: rect.bottom - rect.top,
          };

          doDrag(evt.offsetX || evt.layerX, evt.offsetY || evt.layerY);

          element($window).on('mousemove', onMouseMove).one('mouseup', onMouseUp);
        };

        // fix to prevent memory leak
        scope.$on('$destroy', () => {
          // remove listener
          element($window).off('mousemove', onMouseMove);
          element($window).off('mouseup', onMouseUp);
        });
        elem.on('$destroy', () => {
          scope.$destroy();
        });
      },
    };
  },
];

export default 'colorPicker';
